module.exports = __webpack_public_path__ + "static/media/comic2011a.mobile.b6175986.png";